//Empty alt
(function () {
  function addEmptyAlt(root) {
    (root || document).querySelectorAll('img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { addEmptyAlt(); });
  } else {
    addEmptyAlt();
  }

  // Cover images added later (menus, carousels, lazy-loaded content)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IMG' && !node.hasAttribute('alt')) {
          node.setAttribute('alt', '');
        } else if (node.querySelectorAll) {
          addEmptyAlt(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
//Empty heading
(function () {
  var SELECTOR = 'h1, h2, h3, h4, h5, h6, [role="heading"]';

  function isEmpty(el) {
    // Keep headings that contain meaningful non-text content
    if (el.querySelector('img[alt]:not([alt=""]), svg[aria-label], svg[role="img"], input, [aria-label]:not([aria-hidden="true"])')) return false;
    if (el.getAttribute('aria-label') && el.getAttribute('aria-label').trim()) return false;
    // Treat nbsp and zero-width characters as empty
    var text = (el.textContent || '').replace(/[\s\u00A0\u200B-\u200D\uFEFF]/g, '');
    return text === '';
  }

  function removeEmptyHeadings(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (h) {
      if (isEmpty(h)) h.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { removeEmptyHeadings(); });
  } else {
    removeEmptyHeadings();
  }

  // Cover headings added or filled in later
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () { removeEmptyHeadings(); }, 100);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
//Discount code input
(function () {
  var INPUT_SEL = 'input.upcart-discount-code-input';
  var ERROR_SEL = '[class*="DiscountCodeModule__error__"]';
  var MESSAGE   = 'Discount code is invalid or cannot be applied. Please check the code and try again.';
  var LIVE_ID   = 'upcart-discount-live';
  var DESC_ID   = 'upcart-discount-error-text';
  var announced = false;

  var HIDDEN_STYLE =
    'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;' +
    'overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';

  // Persistent live region outside the app's DOM, created once and early
  function getLive() {
    var el = document.getElementById(LIVE_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = LIVE_ID;
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');
    el.style.cssText = HIDDEN_STYLE;
    document.body.appendChild(el);
    return el;
  }

  // Static text for aria-describedby (separate from the live region so it isn't announced twice)
  function getDesc() {
    var el = document.getElementById(DESC_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = DESC_ID;
    el.style.cssText = HIDDEN_STYLE;
    el.textContent = MESSAGE;
    document.body.appendChild(el);
    return el;
  }

  function sync() {
    var live = getLive();
    getDesc();

    document.querySelectorAll(INPUT_SEL).forEach(function (input) {
      // Re-applied every pass in case the app re-renders the input
      if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
        input.setAttribute('aria-label', 'Discount code');
      }

      var wrapper  = input.closest('form') || input.parentElement;
      var errorEl  = wrapper && wrapper.querySelector(ERROR_SEL);

      if (errorEl) {
        errorEl.setAttribute('aria-hidden', 'true');
        errorEl.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        });
        if (input.getAttribute('aria-invalid') !== 'true') input.setAttribute('aria-invalid', 'true');
        if (input.getAttribute('aria-describedby') !== DESC_ID) input.setAttribute('aria-describedby', DESC_ID);

        if (!announced) {
          announced = true;
          setTimeout(function () { live.textContent = MESSAGE; }, 50);
        }
      } else {
        if (input.hasAttribute('aria-invalid')) input.removeAttribute('aria-invalid');
        if (input.getAttribute('aria-describedby') === DESC_ID) input.removeAttribute('aria-describedby');
        announced = false;
        if (live.textContent) live.textContent = '';
      }
    });
  }

  // Delegated submit handler: works for forms added at any time
  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('form.upcart-discount-code-row')) return;
    announced = false;
    var live = document.getElementById(LIVE_ID);
    if (live) live.textContent = '';
    // The app validates asynchronously, so re-check after it responds
    setTimeout(sync, 600);
    setTimeout(sync, 1500);
    setTimeout(sync, 3000);
  }, true);

  function init() {
    getLive();
    getDesc();
    sync();

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 100);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//Survey Popup
(function () {
  var SURVEY_SEL = '[id^="hotjar-survey-"]';
  var HAS_TEXT = /[\p{L}\p{N}]/u;
  var HIDDEN_STYLE =
    'position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;' +
    'padding:0!important;border:0!important;overflow:hidden!important;' +
    'clip:rect(0,0,0,0)!important;white-space:nowrap!important;';

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function textOf(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  // Radios: give every <label> real text, fix names, remove empty aria-describedby
  function fixRadios(survey) {
    var groups = {};
    survey.querySelectorAll('input[type="radio"]').forEach(function (input) {
      (groups[input.name] = groups[input.name] || []).push(input);
    });

    Object.keys(groups).forEach(function (name) {
      var radios = groups[name];
      var scope = radios[0].closest('fieldset') || survey;
      var startText = textOf(scope.querySelector('[id^="hj-surveys-scale-option-label-0"]'));
      var endText = textOf(scope.querySelector('[id^="hj-surveys-scale-option-label-1"]'));

      radios.forEach(function (input, i) {
        // Work out the name: keep a good existing aria-label, otherwise build one
        var name = input.getAttribute('aria-label') || '';
        if (!HAS_TEXT.test(name)) {
          name = String(i + 1);
          if (i === 0 && startText) name += ' - ' + startText;
          else if (i === radios.length - 1 && endText) name += ' - ' + endText;
        }
        setAttr(input, 'aria-label', name);

        if (input.hasAttribute('aria-describedby')) input.removeAttribute('aria-describedby');

        var label = input.closest('label');
        if (label) {
          // Visually hidden text inside the label, so the label is not empty
          var span = label.querySelector('.zc-hj-label-text');
          if (!span) {
            span = document.createElement('span');
            span.className = 'zc-hj-label-text';
            span.style.cssText = HIDDEN_STYLE;
            label.appendChild(span);
          }
          if (span.textContent !== name) span.textContent = name;
        }

        // Emoji SVG is decorative
        if (label) {
          label.querySelectorAll('svg').forEach(function (svg) {
            setAttr(svg, 'aria-hidden', 'true');
            setAttr(svg, 'focusable', 'false');
          });
        }
      });
    });
  }

  // Fieldset: remove aria-labelledby IDs that do not exist
  function fixFieldsets(survey) {
    survey.querySelectorAll('fieldset[aria-labelledby]').forEach(function (fs) {
      var ids = fs.getAttribute('aria-labelledby').split(/\s+/).filter(Boolean);
      var valid = ids.filter(function (id) { return document.getElementById(id); });
      if (valid.length !== ids.length) {
        if (valid.length) setAttr(fs, 'aria-labelledby', valid.join(' '));
        else fs.removeAttribute('aria-labelledby');
      }
    });
  }

  // Legend: role="heading" overrides legend semantics
  function fixLegends(survey) {
    survey.querySelectorAll('legend[role="heading"]').forEach(function (l) {
      l.removeAttribute('role');
    });
  }

  // Radiogroup: name it with the question
  function fixRadioGroups(survey) {
    survey.querySelectorAll('[role="radiogroup"]').forEach(function (rg) {
      if (rg.hasAttribute('aria-label') || rg.hasAttribute('aria-labelledby')) return;
      var fs = rg.closest('fieldset');
      var legend = fs && fs.querySelector('legend[id]');
      if (legend) setAttr(rg, 'aria-labelledby', legend.id);
    });
  }

  // Toggle button: type and expanded state
  function fixToggle(survey) {
    survey.querySelectorAll('button[id^="hj-survey-toggle-"]').forEach(function (btn) {
      setAttr(btn, 'type', 'button');
      var label = (btn.getAttribute('aria-label') || '').toLowerCase();
      if (/^(hide|collapse|minimi[sz]e|close)/.test(label)) setAttr(btn, 'aria-expanded', 'true');
      else if (/^(show|open|expand|maximi[sz]e)/.test(label)) setAttr(btn, 'aria-expanded', 'false');
      var svg = btn.querySelector('svg');
      if (svg) setAttr(svg, 'aria-hidden', 'true');
    });
  }

  function run() {
    document.querySelectorAll(SURVEY_SEL).forEach(function (survey) {
      fixRadios(survey);
      fixFieldsets(survey);
      fixLegends(survey);
      fixRadioGroups(survey);
      fixToggle(survey);
    });
  }

  function init() {
    run();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//3rd Party Merchant Frame title
(function () {
  var TITLE = 'Google Customer Reviews badge';

  function fix() {
    var frame = document.getElementById('merchantwidgetiframe');
    if (frame && frame.getAttribute('title') !== TITLE) {
      frame.setAttribute('title', TITLE);
    }
  }

  function init() {
    fix();
    // The widget is injected after load and may be re-rendered
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(fix, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//Cart popup keyboard focus
(function () {
  var wasOpen = false;
  var opener = null;

  function getPopup() { return document.getElementById('CartPopup'); }
  function getRoot() { return document.getElementById('UpcartPopup'); }
  function getBackdrop() { return document.getElementById('UpcartPopupBackDrop'); }

  // Class names carry a hashed suffix, so match by prefix
  function isOpen(popup) {
    return Array.prototype.some.call(popup.classList, function (c) {
      return c.indexOf('styles_active__') === 0;
    });
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"][tabindex]'),
      function (el) {
        return !el.disabled && !el.closest('[inert]') && el.getAttribute('aria-hidden') !== 'true' &&
               (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      }
    );
  }

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function sync() {
    var popup = getPopup();
    var root = getRoot();
    if (!popup || !root) return;

    var open = isOpen(popup);
    var backdrop = getBackdrop();

    // Dialog semantics
    setAttr(popup, 'role', 'dialog');
    setAttr(popup, 'aria-modal', 'true');
    if (!popup.hasAttribute('aria-label')) popup.setAttribute('aria-label', 'Shopping cart');

    if (backdrop) setAttr(backdrop, 'aria-hidden', 'true');

    if (open) {
      // inert and aria-hidden removed so the cart is reachable
      if (root.hasAttribute('inert')) root.removeAttribute('inert');
      if (popup.hasAttribute('aria-hidden')) popup.removeAttribute('aria-hidden');

      if (!wasOpen) {
        opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
        setTimeout(function () {
          var close = popup.querySelector('.upcart-header-close-button');
          (close || popup).focus();
        }, 50);
      }
    } else {
      // Closed: removed from tab order and from the accessibility tree
      if (!root.hasAttribute('inert')) root.setAttribute('inert', '');
      setAttr(popup, 'aria-hidden', 'true');

      if (wasOpen && opener && document.contains(opener)) {
        try { opener.focus(); } catch (e) {}
        opener = null;
      }
    }
    wasOpen = open;
  }

  // Close button is a div with role=button: make Enter/Space work
  // Track Tab direction so focus can be returned to the right end
  var lastShift = false;

  document.addEventListener('keydown', function (e) {
    var popup = getPopup();
    if (!popup || !isOpen(popup)) return;

    var closeBtn = popup.querySelector('.upcart-header-close-button');

    if (e.key === 'Escape') {
      if (closeBtn) { e.preventDefault(); closeBtn.click(); }
      return;
    }

    if ((e.key === 'Enter' || e.key === ' ') && e.target === closeBtn) {
      e.preventDefault();
      closeBtn.click();
      return;
    }

    // No manual Tab handling: native order reaches products, coupon and checkout
    if (e.key === 'Tab') lastShift = e.shiftKey;
  }, true);

  // Only if focus escapes the open cart, bring it back
  document.addEventListener('focusin', function (e) {
    var popup = getPopup();
    if (!popup || !isOpen(popup)) return;

    var path = e.composedPath ? e.composedPath() : [e.target];
    if (path.indexOf(popup) > -1) return; // still inside (including shadow DOM)

    var target;
    if (lastShift) {
      // Shift+Tab from the first element: wrap to the end (checkout area)
      var host = popup.querySelector('shipaid-widget');
      var inner = host && host.shadowRoot && host.shadowRoot.querySelector('a[href], button');
      var items = focusables(popup);
      target = inner || items[items.length - 1];
    } else {
      target = popup.querySelector('.upcart-header-close-button');
    }
    if (target) target.focus();
  });

  // Keep dialog state in sync with the popup's open/closed class
  var syncTimer;
  new MutationObserver(function () {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 50);
  }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });

  sync();
})();

//Cart remove and accordion button
(function () {
  var TOGGLE_SEL = 'button[class*="BundleProperties__toggleButton"]';
  var TRASH_SEL  = '[class*="TrashButton__deleteButton"]';
  var ITEM_SEL   = '.upcart-product-item';
  var TITLE_SEL  = '.upcart-product-title';

  function setAttr(el, n, v) {
    if (el.getAttribute(n) !== v) el.setAttribute(n, v);
  }

  function hideSvgs(el) {
    el.querySelectorAll('svg').forEach(function (svg) {
      setAttr(svg, 'aria-hidden', 'true');
      setAttr(svg, 'focusable', 'false');
    });
  }

  function productTitle(el) {
    var item = el.closest(ITEM_SEL);
    var t = item && item.querySelector(TITLE_SEL);
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // "Show 4 items" = collapsed, "Hide 4 items" = expanded
  function fixToggle(btn) {
    setAttr(btn, 'type', 'button');
    hideSvgs(btn);
    var text = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var expanded = /^(hide|collapse|show less|close)/.test(text);
    setAttr(btn, 'aria-expanded', expanded ? 'true' : 'false');
  }

  // Trash icon is a div: make it a real, keyboard-operable button
  function fixTrash(el) {
    setAttr(el, 'role', 'button');
    setAttr(el, 'tabindex', '0');
    hideSvgs(el);
    var title = productTitle(el);
    setAttr(el, 'aria-label', title ? 'Remove ' + title + ' from cart' : 'Remove item from cart');
  }

  function run() {
    document.querySelectorAll(TOGGLE_SEL).forEach(fixToggle);
    document.querySelectorAll(TRASH_SEL).forEach(fixTrash);
  }

  // Enter and Space activate the remove control
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (t && t.matches && t.matches(TRASH_SEL)) {
      e.preventDefault();
      t.click();
    }
  }, true);

  // Re-check the toggle state after it is clicked, once UpCart has re-rendered
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(TOGGLE_SEL);
    if (btn) {
      setTimeout(run, 50);
      setTimeout(run, 300);
    }
  }, true);

  function init() {
    run();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//Cart remove and accordion button
(function () {
  var TOGGLE_SEL = 'button[class*="BundleProperties__toggleButton"]';
  var TRASH_SEL  = '[class*="TrashButton__deleteButton"]';
  var ITEM_SEL   = '.upcart-product-item';
  var TITLE_SEL  = '.upcart-product-title';

  function setAttr(el, n, v) {
    if (el.getAttribute(n) !== v) el.setAttribute(n, v);
  }

  function hideSvgs(el) {
    el.querySelectorAll('svg').forEach(function (svg) {
      setAttr(svg, 'aria-hidden', 'true');
      setAttr(svg, 'focusable', 'false');
    });
  }

  function productTitle(el) {
    var item = el.closest(ITEM_SEL);
    var t = item && item.querySelector(TITLE_SEL);
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // "Show 4 items" = collapsed, "Hide 4 items" = expanded
  function fixToggle(btn) {
    setAttr(btn, 'type', 'button');
    hideSvgs(btn);
    var text = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var expanded = /^(hide|collapse|show less|close)/.test(text);
    setAttr(btn, 'aria-expanded', expanded ? 'true' : 'false');
  }

  // Trash icon is a div: make it a real, keyboard-operable button
  function fixTrash(el) {
    setAttr(el, 'role', 'button');
    setAttr(el, 'tabindex', '0');
    hideSvgs(el);
    var title = productTitle(el);
    setAttr(el, 'aria-label', title ? 'Remove ' + title + ' from cart' : 'Remove item from cart');
  }

  function run() {
    document.querySelectorAll(TOGGLE_SEL).forEach(fixToggle);
    document.querySelectorAll(TRASH_SEL).forEach(fixTrash);
  }

  // Enter and Space activate the remove control
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (t && t.matches && t.matches(TRASH_SEL)) {
      e.preventDefault();
      t.click();
    }
  }, true);

  // Re-check the toggle state after it is clicked, once UpCart has re-rendered
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(TOGGLE_SEL);
    if (btn) {
      setTimeout(run, 50);
      setTimeout(run, 300);
    }
  }, true);

  function init() {
    run();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//Review Popup
(function () {
  var s = document.createElement('script');
  s.textContent = `
    (function () {
      var CONTAINER_ID = 'yotpo-reviews-tab';
      var FLOATING_TAB_SEL = '.yotpo-reviews-tab-floating-tab';
      var DRAWER_SEL = '.reviews-tab-drawer';
      var DRAWER_CONTAINER_SEL = '.reviews-tab-drawer-container';
      var BACKDROP_SEL = '.reviews-tab-modal-backdrop';
      var VISIBLE_CLASS = 'reviews-tab-drawer-container-visible';

      function focusables(root) {
        return Array.prototype.filter.call(
          root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (el) {
            return el.getAttribute('aria-hidden') !== 'true' &&
                   (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
          }
        );
      }

      function setAttr(el, n, v) {
        if (el && el.getAttribute(n) !== v) el.setAttribute(n, v);
      }

      function fixFloatingTabs(root) {
        root.querySelectorAll(FLOATING_TAB_SEL).forEach(function (tab) {
          if (tab.dataset.a11yBound === 'true') return;
          tab.dataset.a11yBound = 'true';

          var label = tab.querySelector('.yotpo-floating-tab-text');
          var text = label ? label.textContent.trim() : 'Reviews';

          setAttr(tab, 'role', 'button');
          setAttr(tab, 'tabindex', '0');
          setAttr(tab, 'aria-label', 'Open ' + text.toLowerCase());

          tab.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              tab.click();
            }
          });
        });
      }

      function isDrawerVisible(container) {
        var drawerContainer = container.querySelector(DRAWER_CONTAINER_SEL);
        return !!(drawerContainer && drawerContainer.classList.contains(VISIBLE_CLASS));
      }

      function trackDrawerState(container) {
        if (container.dataset.a11yStateBound === 'true') return;
        container.dataset.a11yStateBound = 'true';

        var opener = null;
        var wasVisible = isDrawerVisible(container);
        var drawer = container.querySelector(DRAWER_SEL);
        var backdrop = container.querySelector(BACKDROP_SEL);

        if (drawer) {
          setAttr(drawer, 'role', 'dialog');
          setAttr(drawer, 'aria-modal', 'true');
          var heading = drawer.querySelector('.yotpo-headline');
          if (heading) {
            if (!heading.id) heading.id = 'yotpo-reviews-heading';
            setAttr(drawer, 'aria-labelledby', heading.id);
          }
        }

        function onOpen() {
          opener = document.activeElement && document.activeElement !== document.body
            ? document.activeElement
            : null;

          setTimeout(function () {
            var items = drawer ? focusables(drawer) : [];
            var target = drawer && drawer.querySelector('.yotpo-headline');
            if (target) {
              if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
              target.focus();
            } else if (items.length) {
              items[0].focus();
            }
          }, 50);

          document.addEventListener('keydown', trapKeydown, true);
        }

        function onClose() {
          document.removeEventListener('keydown', trapKeydown, true);
          if (opener && document.contains(opener)) {
            try { opener.focus(); } catch (e) {}
          }
          opener = null;
        }

        function trapKeydown(e) {
          if (!isDrawerVisible(container)) return;

          if (e.key === 'Escape') {
            e.preventDefault();
            if (backdrop) backdrop.click();
            return;
          }

          if (e.key !== 'Tab' || !drawer) return;

          var items = focusables(drawer);
          if (!items.length) return;

          var first = items[0];
          var last = items[items.length - 1];
          var active = document.activeElement;

          if (e.shiftKey && active === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
          }
        }

        new MutationObserver(function () {
          var visible = isDrawerVisible(container);
          if (visible === wasVisible) return;
          wasVisible = visible;
          if (visible) onOpen();
          else onClose();
        }).observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
      }

      function runFixes(container) {
        fixFloatingTabs(container);
        trackDrawerState(container);
      }

      function scan(node) {
        if (node.id === CONTAINER_ID) {
          runFixes(node);
          return;
        }
        if (node.querySelectorAll) {
          var found = node.querySelector ? node.querySelector('#' + CONTAINER_ID) : null;
          if (found) runFixes(found);
        }
      }

      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });

      var existing = document.getElementById(CONTAINER_ID);
      if (existing) runFixes(existing);
    })();
  `;
  document.head.appendChild(s);
})();
// Review popup
(function () {
  var DRAWER_SEL = '.reviews-tab-drawer-container';
  var opener = null;
  var wasOpen = false;
  var uid = 0;

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function getDrawer() { return document.querySelector(DRAWER_SEL); }

  function isOpen(d) {
    return !!d && d.classList.contains('reviews-tab-drawer-container-visible') && visible(d);
  }

  function widgetRoot(d) { return d.closest('#yotpo-reviews-tab') || document; }

  // The visible floating tab that is NOT the "Open reviews" button.
  // It can sit inside the drawer container, so do not exclude it.
  function closeTab(d) {
    var tabs = widgetRoot(d).querySelectorAll('.yotpo-reviews-tab-floating-tab');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      if (t.getAttribute('aria-label') === 'Open reviews') continue;
      if (t.getAttribute('data-a11y-bound')) continue;
      if (visible(t)) return t;
    }
    return null;
  }

  function fullClick(el) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      var Ctor = type.indexOf('pointer') === 0 && window.PointerEvent ? PointerEvent : MouseEvent;
      el.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window }));
    });
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return !el.disabled && !el.closest('[inert]') && el.getAttribute('aria-hidden') !== 'true' && visible(el);
      }
    );
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d || !isOpen(d)) return;

    var attempts = [
      function () { var t = closeTab(d); if (t) t.click(); },
      function () { var t = closeTab(d); if (t) fullClick(t); },
      function () { var b = widgetRoot(d).querySelector('.reviews-tab-modal-backdrop'); if (b) fullClick(b); },
      function () {
        var o = widgetRoot(d).querySelector('[aria-label="Open reviews"]');
        if (o) fullClick(o);
      }
    ];

    (function next(i) {
      if (i >= attempts.length) return;
      try { attempts[i](); } catch (e) {}
      setTimeout(function () {
        var dd = getDrawer();
        if (dd && isOpen(dd)) next(i + 1);
      }, 200);
    })(0);
  }

  function sync() {
    var d = getDrawer();
    if (!d) return;
    var open = isOpen(d);

    var heading = d.querySelector('.yotpo-headline');
    if (heading && !heading.id) heading.id = 'yotpo-reviews-title-' + (++uid);
    setAttr(d, 'role', 'dialog');
    setAttr(d, 'aria-modal', 'true');
    if (heading) setAttr(d, 'aria-labelledby', heading.id);
    else setAttr(d, 'aria-label', 'Customer testimonials');
    if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');

    if (open) {
      d.removeAttribute('inert');
      d.removeAttribute('aria-hidden');
    } else {
      setAttr(d, 'inert', '');
      setAttr(d, 'aria-hidden', 'true');
    }

    document.querySelectorAll('.reviews-tab-modal-backdrop').forEach(function (b) {
      setAttr(b, 'aria-hidden', 'true');
    });

    document.querySelectorAll('#yotpo-reviews-tab [aria-label="Open reviews"]').forEach(function (b) {
      setAttr(b, 'role', 'button');
      setAttr(b, 'aria-haspopup', 'dialog');
      setAttr(b, 'aria-expanded', open ? 'true' : 'false');
    });

    var ct = closeTab(d);
    if (ct) {
      setAttr(ct, 'role', 'button');
      setAttr(ct, 'tabindex', '0');
      setAttr(ct, 'aria-label', 'Close reviews');
      ct.setAttribute('data-zc-close', '1');
    }

    var panel = d.querySelector('#yotpo-tab-reviews-container');
    var sel = d.querySelector('[role="tab"][aria-selected="true"]');
    if (panel && sel) {
      if (!sel.id) sel.id = 'yotpo-tab-' + (++uid);
      setAttr(panel, 'role', 'tabpanel');
      setAttr(panel, 'aria-labelledby', sel.id);
    }

    if (open && !wasOpen) {
      var a = document.activeElement;
      opener = a && a !== document.body && !d.contains(a) ? a : null;
      setTimeout(function () { d.focus(); }, 50);
    } else if (!open && wasOpen) {
      if (opener && opener.isConnected && visible(opener)) {
        try { opener.focus(); } catch (e) {}
      } else {
        var ob = document.querySelector('#yotpo-reviews-tab [aria-label="Open reviews"]');
        if (ob) { try { ob.focus(); } catch (e2) {} }
      }
      opener = null;
    }
    wasOpen = open;
  }

  document.addEventListener('keydown', function (e) {
    var d = getDrawer();
    if (!d || !isOpen(d)) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
      return;
    }

    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.getAttribute &&
        e.target.getAttribute('data-zc-close') === '1') {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
      return;
    }

    if (e.key === 'Tab') {
      var items = focusables(d);
      if (!items.length) { e.preventDefault(); d.focus(); return; }
      var first = items[0], last = items[items.length - 1], act = document.activeElement;
      var inside = items.indexOf(act) > -1;
      if (e.shiftKey && (!inside || act === first)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (!inside || act === last)) { e.preventDefault(); first.focus(); }
    }
  }, true);

  function init() {
    sync();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 60);
    }).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
// Product Checkboxes
(function () {
  var GROUP_SEL = '#options-buttons .buttons';

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function sync() {
    var group = document.querySelector(GROUP_SEL);
    if (!group) return;
    var radios = group.querySelectorAll('button');
    if (!radios.length) return;

    setAttr(group, 'role', 'radiogroup');
    setAttr(group, 'aria-label', 'Subscription length');
    var desc = document.getElementById('subscribe-text');
    if (desc) setAttr(group, 'aria-describedby', 'subscribe-text');

    // Checked = the button with .active; fall back to the first one
    var checked = group.querySelector('button.active') || radios[0];

    radios.forEach(function (btn) {
      var isChecked = btn === checked;
      setAttr(btn, 'type', 'button');
      setAttr(btn, 'role', 'radio');
      setAttr(btn, 'aria-checked', isChecked ? 'true' : 'false');
      // Roving tabindex: only the selected radio is in the Tab order
      setAttr(btn, 'tabindex', isChecked ? '0' : '-1');
    });
  }

  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest(GROUP_SEL + ' button');
    if (!btn) return;
    var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
    if (keys.indexOf(e.key) === -1) return;

    var radios = Array.prototype.slice.call(btn.closest(GROUP_SEL).querySelectorAll('button'));
    var i = radios.indexOf(btn), next;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = radios[(i + 1) % radios.length];
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = radios[(i - 1 + radios.length) % radios.length];
    else if (e.key === 'Home') next = radios[0];
    else next = radios[radios.length - 1];

    e.preventDefault();
    next.click();          // runs your existing selection logic
    setTimeout(function () { sync(); next.focus(); }, 0);
  });

  // Keep state right after a mouse click too
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(GROUP_SEL + ' button')) setTimeout(sync, 0);
  });

  function init() {
    sync();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 50);
    }).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
//Bundle Buttons
(function () {
  var SEL = '.gbbExtBundleRedirectButton';

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function sync() {
    var items = document.querySelectorAll(SEL);
    items.forEach(function (el, i) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      var upsell = el.closest('.gbbExtBundleUpsell');
      var id = upsell && upsell.getAttribute('bundleid');

      setAttr(el, 'role', 'link');
      setAttr(el, 'tabindex', '0');

      // Starts with the visible text (label-in-name), plus a suffix so
      // multiple identical links are distinguishable
      var suffix = items.length > 1 ? ', bundle ' + (id || (i + 1)) : '';
      setAttr(el, 'aria-label', text + suffix);
    });
  }

  // Links activate with Enter (not Space)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    e.preventDefault();
    el.click(); // runs the app's existing redirect
  });

  // Visible focus indicator for keyboard users
  var style = document.createElement('style');
  style.textContent = SEL + ':focus-visible{outline:3px solid #000;outline-offset:2px;box-shadow:0 0 0 5px #fff;}';
  document.head.appendChild(style);

  function init() {
    sync();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
//Same page link 
(function () {
  var SEL = '#more-payment-options-link';

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function sync() {
    document.querySelectorAll(SEL).forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim() || 'More payment options';
      // Not a navigation link: it is a JS action, so drop the "#" link semantics
      setAttr(el, 'role', 'button');
      // Starts with the visible text (label-in-name)
      setAttr(el, 'aria-label', text + ', continues to checkout');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }

  // Buttons also activate with Space (links only respond to Enter)
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ') return;
    var el = e.target.closest && e.target.closest(SEL);
    if (!el || el.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    el.click();
  });

  function init() {
    sync();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
//Build Bundle
function simulateClick(el) {
  // A real mouse click can originate at a descendant (e.g. the <img> or
  // overlay div inside .gbbProductImageContainer) and bubble up, so both
  // the descendant's own handler and any handler on el fire. el.click()
  // only bubbles UP from el, so it never reaches a handler bound to one
  // of el's children - which is why keyboard activation was silent here.
  // Dispatching the sequence at the innermost likely target instead
  // reproduces that same bubble path.
  var target = el.querySelector('img, .gbbProductItemOverLay, .gbbOverLayIconContainer') || el;
  ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
    var EventCtor = (type.indexOf('pointer') === 0 && window.PointerEvent) ? PointerEvent : MouseEvent;
    target.dispatchEvent(new EventCtor(type, { bubbles: true, cancelable: true, view: window }));
  });
}
(function () {
  var ROOT_SEL = '#gbbBundle';
  var NATIVE = 'a[href],button,input,select,textarea,summary,[tabindex],[role]';
  var lastTrigger = null, drawerWasOpen = false, uid = 0;

  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function vis(el) { return !!(el && el.getClientRects().length); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function idOf(el, prefix) { if (!el.id) el.id = prefix + (++uid); return el.id; }
  function isNative(el) { return /^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(el.tagName) && (el.tagName !== 'A' || el.hasAttribute('href')); }

  // Turn a div/span/a into a keyboard-operable button
  function makeButton(el, label, role) {
    if (isNative(el)) return;
    setAttr(el, 'role', role || 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    el.setAttribute('data-zc', '1');
    if (label) setAttr(el, 'aria-label', label);
    var dis = /disabled|soldout|sold-out/i.test(el.className || '');
    setAttr(el, 'aria-disabled', dis ? 'true' : 'false');
  }

  function itemTitle(item) {
    var t = item && item.querySelector('.gbbProductTitleOnly');
    return txt(t).replace(/\s*\|\s*/g, ', ');
  }

  function cardTitle(el) {
    var p = el.parentElement;
    for (var i = 0; p && i < 6; i++, p = p.parentElement) {
      if (p.matches(ROOT_SEL + ',.gbbFooterProductsContainer,.gbbDrawerBody,.gbbDrawer')) break;
      var t = p.querySelector('[class*="Title"]:not([class*="Variant"])');
      if (t && !el.contains(t)) return txt(t);
    }
    return '';
  }

  function guessLabel(el) {
    var c = String(el.className || '');
    var base = '';
    if (/remove|delete|trash/i.test(c)) base = 'Remove';
    else if (/minus|decrease|decrement/i.test(c)) base = 'Decrease quantity of';
    else if (/plus|increase|increment/i.test(c)) base = 'Increase quantity of';
    else if (/close/i.test(c)) return 'Close';
    else if (/next/i.test(c)) return 'Next';
    else if (/prev/i.test(c)) return 'Previous';
    if (!base) return '';
    var t = cardTitle(el);
    return base + (t ? ' ' + t : ' item');
  }

  function sync() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    setAttr(root, 'role', 'region');
    setAttr(root, 'aria-label', 'Build your bundle');

    // Decorative icons and images
    all('svg', document).forEach(function (s) {
      if (s.closest(ROOT_SEL + ',.gbbDrawer')) { setAttr(s, 'aria-hidden', 'true'); setAttr(s, 'focusable', 'false'); }
    });
    all('img:not([alt])', root).forEach(function (i) { i.setAttribute('alt', ''); });
    all('.gbbProductItemOverLay, .gbbEmptyProductCard', root).forEach(function (e) { setAttr(e, 'aria-hidden', 'true'); });

    // Headings
    all('.gbbFooterBundleTitle', root).forEach(function (h) { setAttr(h, 'role', 'heading'); setAttr(h, 'aria-level', '2'); });

    // Product lists
    all('.gbbProductsItemsContainer', root).forEach(function (l) { setAttr(l, 'role', 'list'); });
    all('.gbbProductItem', root).forEach(function (it) {
  setAttr(it, 'role', 'listitem');
  var title = itemTitle(it);
  var add = it.querySelector('.gbbProductAddButton');
  if (add) makeButton(add, title ? 'Add ' + title + ' to bundle' : 'Add to bundle');
  var imageBtn = it.querySelector('.gbbProductImageContainer');
  if (imageBtn) makeButton(imageBtn, title ? 'View ' + title : 'View product image');
  var prev = it.querySelector('.gbbPrevImage'), next = it.querySelector('.gbbNextImage');
  if (prev && vis(prev)) makeButton(prev, 'Previous image' + (title ? ' of ' + title : ''));
  if (next && vis(next)) makeButton(next, 'Next image' + (title ? ' of ' + title : ''));
  all('.gbbPrevImage,.gbbNextImage', it).forEach(function (a) { if (!vis(a)) { a.removeAttribute('tabindex'); } });
});

    // Category dropdown (mobile)
    var active = root.querySelector('.gbbActiveCategoryContainer');
    var list = root.querySelector('.gbbCategoryOptionsContainer');
    if (active && list) {
      var open = vis(list);
      makeButton(active, txt(active.querySelector('.gbbActiveCategoryTitle')) + ', choose category');
      setAttr(active, 'aria-haspopup', 'listbox');
      setAttr(active, 'aria-expanded', open ? 'true' : 'false');
      setAttr(active, 'aria-controls', idOf(list, 'zc-gbb-list-'));
      setAttr(list, 'role', 'listbox');
      setAttr(list, 'aria-label', 'Categories');
      var cur = active.getAttribute('categoryid');
      all('.gbbCategoryOption', list).forEach(function (o) {
        makeButton(o, null, 'option');
        setAttr(o, 'aria-selected', o.getAttribute('categoryid') === cur ? 'true' : 'false');
      });
    }

    // Category tabs (desktop) and panels
    var tablist = root.querySelector('.gbbMultipleCategoryTabsContainer');
    var tabsVisible = !!tablist && vis(tablist);
    if (tablist) {
      setAttr(tablist, 'role', 'tablist');
      setAttr(tablist, 'aria-label', 'Product categories');
      all('.gbbCategoryTabContainer', tablist).forEach(function (t) {
        var on = t.getAttribute('data-is-active') === 'true';
        makeButton(t, null, 'tab');
        setAttr(t, 'aria-selected', on ? 'true' : 'false');
        setAttr(t, 'tabindex', on ? '0' : '-1');
        t.id = 'zc-gbb-tab-' + t.getAttribute('categoryid');
      });
    }
    all('.gbbCategoryContainer', root).forEach(function (p) {
      var cid = p.getAttribute('categoryid');
      var tab = document.getElementById('zc-gbb-tab-' + cid);
      setAttr(p, 'role', tabsVisible ? 'tabpanel' : 'region');
      if (tab) setAttr(p, 'aria-labelledby', tab.id);
      var head = p.querySelector('.gbbCategoryHeaderContainer');
      if (head && vis(head)) {
        makeButton(head, null);
        setAttr(head, 'aria-expanded', p.getAttribute('data-is-active') === 'true' ? 'true' : 'false');
        head.removeAttribute('aria-label');
      }
    });

    // Footer
    var clear = root.querySelector('.gbbFooterClearItemsButtonWrapper');
    if (clear) makeButton(clear, 'Clear all items from bundle');
    var count = root.querySelector('.gbbFooterTotalItemsInCart');
    if (count) { setAttr(count, 'role', 'status'); setAttr(count, 'aria-live', 'polite'); }
    var msg = root.querySelector('.gbbDiscountMessage');
    if (msg) { setAttr(msg, 'role', 'status'); setAttr(msg, 'aria-live', 'polite'); }
    var bar = root.querySelector('.gbbDiscountProgressBarContainer .progressBar');
    var fill = bar && bar.querySelector('.progressBarFill');
    if (bar && fill) {
      var w = parseFloat(fill.style.width) || 0;
      setAttr(bar, 'role', 'progressbar');
      setAttr(bar, 'aria-label', 'Progress toward bundle discount');
      setAttr(bar, 'aria-valuemin', '0');
      setAttr(bar, 'aria-valuemax', '100');
      setAttr(bar, 'aria-valuenow', String(Math.round(w)));
      if (msg) setAttr(bar, 'aria-valuetext', txt(msg));
    }
    var nextBtn = root.querySelector('.gbbFooterNextButton');
    if (nextBtn) makeButton(nextBtn, txt(nextBtn) || 'Add to cart');

    // Variant drawer
    all('.gbbDrawer').forEach(function (d) {
      var open = d.getAttribute('data-drawer-status') !== 'closed';
      setAttr(d, 'role', 'dialog');
      setAttr(d, 'aria-modal', 'true');
      setAttr(d, 'aria-label', 'Select options');
      if (open) { d.removeAttribute('inert'); d.removeAttribute('aria-hidden'); }
      else { setAttr(d, 'inert', ''); setAttr(d, 'aria-hidden', 'true'); }
      var content = d.querySelector('.gbbDrawerContentContainer');
      if (content && !content.hasAttribute('tabindex')) content.setAttribute('tabindex', '-1');

      if (open && !drawerWasOpen) {
        drawerWasOpen = true;
        setTimeout(function () {
          var f = focusables(d)[0];
          (f || content || d).focus();
        }, 80);
      } else if (!open && drawerWasOpen) {
        drawerWasOpen = false;
        if (lastTrigger && lastTrigger.isConnected && vis(lastTrigger)) { try { lastTrigger.focus(); } catch (e) {} }
      }
    });

    // Fallback: any remaining clickable div/span (cursor:pointer) that has no role yet
    all(ROOT_SEL + ' *, .gbbDrawer *').forEach(function (el) {
      if (el.matches(NATIVE) || el.closest('svg') || !vis(el)) return;
      if (!/^(DIV|SPAN|LI|P|LABEL|IMG)$/.test(el.tagName)) return;
      if (getComputedStyle(el).cursor !== 'pointer') return;
      var par = el.parentElement;
      if (par && getComputedStyle(par).cursor === 'pointer') return;
      if (el.querySelector(NATIVE)) return;
      var label = txt(el) ? null : guessLabel(el);
      if (!txt(el) && !label) { if (window.console) console.warn('GBB a11y: clickable element needs a manual label', el); return; }
      makeButton(el, label);
    });
  }

  function focusables(root) {
    return all('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])', root).filter(function (el) {
      return !el.disabled && el.getAttribute('aria-disabled') !== 'true' && !el.closest('[inert]') && vis(el);
    });
  }

  function openDrawer() {
    return document.querySelector('.gbbDrawer:not([data-drawer-status="closed"])');
  }

  document.addEventListener('mousedown', function (e) {
    lastTrigger = (e.target.closest && e.target.closest('[data-zc]')) || null;
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    var d = openDrawer();

    if (d && d.getAttribute('role') === 'dialog') {
      if (e.key === 'Escape') {
        var c = d.querySelector('[class*="lose"]');
        if (c) { e.preventDefault(); e.stopPropagation(); c.click(); }
        return;
      }
      if (e.key === 'Tab') {
        var items = focusables(d);
        if (!items.length) { e.preventDefault(); return; }
        var first = items[0], last = items[items.length - 1], inside = d.contains(document.activeElement);
        if (e.shiftKey && (!inside || document.activeElement === first)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (!inside || document.activeElement === last)) { e.preventDefault(); first.focus(); }
        return;
      }
    }

    // Dropdown: Escape closes
    if (e.key === 'Escape') {
      var list = document.querySelector('.gbbCategoryOptionsContainer');
      var act = document.querySelector('.gbbActiveCategoryContainer');
      if (list && act && vis(list) && t.closest && t.closest('.gbbMultipleCategoriesDropdownContainer')) {
        e.preventDefault(); act.click(); act.focus();
      }
      return;
    }

    if (!t || !t.closest) return;

    // Tabs: arrow keys
    var tab = t.closest('.gbbCategoryTabContainer');
    if (tab && ['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(e.key) > -1) {
      var tabs = all('.gbbCategoryTabContainer', tab.parentElement), i = tabs.indexOf(tab), n;
      if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') n = tabs[0]; else n = tabs[tabs.length - 1];
      e.preventDefault(); n.click();
      setTimeout(function () { sync(); n.focus(); }, 0);
      return;
    }

    // Listbox options: arrow keys
    var opt = t.closest('.gbbCategoryOption');
    if (opt && ['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) > -1) {
      var opts = all('.gbbCategoryOption', opt.parentElement), j = opts.indexOf(opt), m;
      if (e.key === 'ArrowDown') m = opts[Math.min(j + 1, opts.length - 1)];
      else if (e.key === 'ArrowUp') m = opts[Math.max(j - 1, 0)];
      else if (e.key === 'Home') m = opts[0]; else m = opts[opts.length - 1];
      e.preventDefault(); m.focus();
      return;
    }

    // Enter / Space activate custom controls
if ((e.key === 'Enter' || e.key === ' ') && t.getAttribute && t.getAttribute('data-zc') === '1' && !isNative(t)) {
  e.preventDefault();
  lastTrigger = t;
  simulateClick(t);
  setTimeout(sync, 60);
}
  }, true);

  document.addEventListener('click', function () { setTimeout(sync, 60); setTimeout(sync, 400); }, true);

  var style = document.createElement('style');
  style.textContent =
    '[data-zc]:focus-visible,.gbbDrawer :focus-visible{outline:3px solid #3C00A0!important;outline-offset:2px;box-shadow:0 0 0 5px #fff!important;}';
  document.head.appendChild(style);

  function init() {
    sync();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 80);
    }).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style', 'data-is-active', 'data-drawer-status']
    });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sync, 150); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
//Bundle popup product
(function () {
  var ROOT_SEL = '.gbbProductVariantModalMainContainer';
  var uid = 0;

  function setAttr(el, n, v) { if (el && el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function vis(el) { return !!(el && el.getClientRects().length); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function idOf(el, prefix) { if (!el.id) el.id = prefix + (++uid); return el.id; }

  function makeButton(el, label) {
    if (!el) return;
    setAttr(el, 'role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    el.setAttribute('data-zc-qv', '1');
    if (label) setAttr(el, 'aria-label', label);
  }

  function focusables(root) {
    return all('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])', root).filter(function (el) {
      return !el.disabled && el.getAttribute('aria-disabled') !== 'true' && vis(el);
    });
  }

  var lastTrigger = null;
  var modalOpen = false;

  // Capture whatever was focused/clicked right before the modal appears,
  // so we can restore focus to it on close (the product title/image that
  // triggered the quick view).
  document.addEventListener('mousedown', function (e) {
    var t = e.target.closest && e.target.closest('.gbbProductItemTitle,.gbbProductImageContainer,[data-zc]');
    if (t && !t.closest(ROOT_SEL)) lastTrigger = t;
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('.gbbProductItemTitle,.gbbProductImageContainer,[data-zc]');
    if (t && !t.closest(ROOT_SEL)) lastTrigger = t;
  }, true);

  function syncModal(modal) {
    var box = modal.querySelector('.gbbProductVariantModalContainer') || modal;
    var title = modal.querySelector('.gbbProductItemTitle');
    var titleText = txt(title) || 'Product options';

    setAttr(box, 'role', 'dialog');
    setAttr(box, 'aria-modal', 'true');
    setAttr(box, 'aria-label', titleText);
    if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');

    // Close button
    var close = modal.querySelector('.gbbProductVariantModalClose');
    makeButton(close, 'Close');

    // Image swapper arrows
    var prev = modal.querySelector('.gbbPrevImage');
    var next = modal.querySelector('.gbbNextImage');
    if (prev && vis(prev)) makeButton(prev, 'Previous image');
    if (next && vis(next)) makeButton(next, 'Next image');

    // Redundant swapped main images are decorative (title/description
    // already convey the product); the visible one plus arrows are the
    // meaningful bits, arrows already labeled above.
    all('.gbbProductImageContainerImg', modal).forEach(function (img) {
      setAttr(img, 'aria-hidden', 'true');
      img.setAttribute('alt', '');
    });

    // Thumbnail strip: make each a real option-like button, mark the
    // active one so it's announced as selected.
    all('.gbbProductTabImageContainer', modal).forEach(function (thumb, i) {
      var img = thumb.querySelector('.gbbProducTabImage');
      var isActive = img && img.classList.contains('gbbActiveImage');
      makeButton(thumb, 'View image ' + (i + 1) + ' of ' + titleText);
      setAttr(thumb, 'aria-pressed', isActive ? 'true' : 'false');
      if (img) setAttr(img, 'alt', '');
    });

    // Quantity stepper
    var qtyGroup = modal.querySelector('.gbbProductQuantityHTML');
    var qtyLabel = modal.querySelector('.gbbProductQuantityLabel');
    var qtyRemove = modal.querySelector('.gbbProductQuantityRemoveButton');
    var qtyAdd = modal.querySelector('.gbbProductQuantityAddButton');
    var qtyValue = txt(qtyLabel);
    if (qtyGroup) { setAttr(qtyGroup, 'role', 'group'); setAttr(qtyGroup, 'aria-label', 'Quantity for ' + titleText); }
    makeButton(qtyRemove, 'Decrease quantity');
    makeButton(qtyAdd, 'Increase quantity');
    if (qtyLabel) {
      setAttr(qtyLabel, 'role', 'status');
      setAttr(qtyLabel, 'aria-live', 'polite');
      setAttr(qtyLabel, 'aria-label', 'Quantity: ' + qtyValue);
    }

    // Add to Bundle
    var addBtn = modal.querySelector('.gbbProductVariantAddButton');
    var price = txt(modal.querySelector('.gbbProductItemPrice'));
    if (addBtn) {
      makeButton(addBtn, 'Add ' + titleText + ' to bundle' + (price ? ', ' + price : '') + (qtyValue ? ', quantity ' + qtyValue : ''));
    }
  }

  function trapKeydown(e) {
    var modal = document.querySelector(ROOT_SEL);
    if (!modal) return;

    if (e.key === 'Escape') {
      var close = modal.querySelector('.gbbProductVariantModalClose');
      if (close) { e.preventDefault(); e.stopPropagation(); close.click(); }
      return;
    }

    if (e.key === 'Tab') {
      var items = focusables(modal);
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      var inside = modal.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (!inside || document.activeElement === last)) { e.preventDefault(); first.focus(); }
      return;
    }

    // Activate our own role="button" elements with Enter/Space
    if ((e.key === 'Enter' || e.key === ' ') && e.target.getAttribute && e.target.getAttribute('data-zc-qv') === '1') {
      var tag = e.target.tagName;
      if (tag !== 'BUTTON' && tag !== 'A') {
        e.preventDefault();
        e.target.click();
        setTimeout(function () { var m = document.querySelector(ROOT_SEL); if (m) syncModal(m); }, 50);
      }
    }
  }

  function onOpen(modal) {
    modalOpen = true;
    syncModal(modal);
    document.addEventListener('keydown', trapKeydown, true);

    setTimeout(function () {
      var box = modal.querySelector('.gbbProductVariantModalContainer') || modal;
      var close = modal.querySelector('.gbbProductVariantModalClose');
      (close || box).focus();
    }, 60);

    // Keep labels in sync as the user changes image/quantity inside the
    // still-open modal (these mutate style/class/text, not the DOM node
    // itself, so the outer add/remove observer below won't catch them).
    var innerObserver = new MutationObserver(function () {
      syncModal(modal);
    });
    innerObserver.observe(modal, {
      attributes: true, attributeFilter: ['style', 'class'],
      childList: true, subtree: true, characterData: true
    });
    modal._a11yInnerObserver = innerObserver;
  }

  function onClose(modal) {
    modalOpen = false;
    document.removeEventListener('keydown', trapKeydown, true);
    if (modal && modal._a11yInnerObserver) modal._a11yInnerObserver.disconnect();
    if (lastTrigger && lastTrigger.isConnected && vis(lastTrigger)) {
      try { lastTrigger.focus(); } catch (e) {}
    }
    lastTrigger = null;
  }

  new MutationObserver(function (mutations) {
    var modal = document.querySelector(ROOT_SEL);
    if (modal && !modalOpen) {
      onOpen(modal);
    } else if (!modal && modalOpen) {
      onClose(null);
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Cover the case where the modal is already in the DOM at script-load time.
  var existing = document.querySelector(ROOT_SEL);
  if (existing) onOpen(existing);
})();
//h1 in bundle page
(function () {
  var ROOT_SEL = '#gbbBundle';

  function addHiddenH1() {
    var root = document.querySelector(ROOT_SEL);
    if (!root || root.querySelector('h1.gbb-visually-hidden-h1')) return;

    var h1 = document.createElement('h1');
    h1.className = 'gbb-visually-hidden-h1';
    h1.textContent = document.title || 'Build your bundle';
    h1.style.cssText =
      'position:absolute;width:1px;height:1px;padding:0;margin:-1px;' +
      'overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';

    root.insertBefore(h1, root.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHiddenH1);
  } else {
    addHiddenH1();
  }
})();
